import React from "react";
import { ProgramsTable } from "../../../../../components/program-library/ProgramsTableScreen";
import { ProgramStatus } from "@growth-machine-llc/stridist-api-client";

interface CoachProgramLibraryListProps {
  status: ProgramStatus;
}

export const CoachProgramLibraryList = ({
  status,
}: CoachProgramLibraryListProps) => {
  return <ProgramsTable status={status} />;
};

export const CoachProgramLibraryPublishedRoute = () => {
  return <CoachProgramLibraryList status={ProgramStatus.PUBLISHED} />;
};

export const CoachProgramLibraryArchivedRoute = () => {
  return <CoachProgramLibraryList status={ProgramStatus.ARCHIVED} />;
};
